import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../utils/supabase'
import { Eye, EyeOff, KeyRound } from 'lucide-react'

export function TrocarSenha() {
  const { profile, logout }         = useAuth()
  const [senhaNova, setSenhaNova]   = useState('')
  const [senhaConf, setSenhaConf]   = useState('')
  const [mostrar, setMostrar]       = useState(false)
  const [erro, setErro]             = useState('')
  const [loading, setLoading]       = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!senhaNova || !senhaConf)  { setErro('Preencha todos os campos'); return }
    if (senhaNova !== senhaConf)   { setErro('As senhas não coincidem'); return }
    if (senhaNova.length < 6)      { setErro('A senha deve ter pelo menos 6 caracteres'); return }

    setLoading(true)
    setErro('')

    const { error } = await supabase.auth.updateUser({ password: senhaNova })
    if (error) { setErro('Erro ao alterar senha. Tente novamente.'); setLoading(false); return }

    // Marca must_change_password = false no perfil
    await supabase
      .from('profiles')
      .update({ must_change_password: false })
      .eq('id', profile.id)

    // Recarrega a página para atualizar o perfil no contexto
    window.location.href = '/'
  }

  return (
    <div className="min-h-screen bg-[#111111] flex flex-col items-center justify-center px-4">

      <div className="mb-8 text-center">
        <div className="inline-flex items-center gap-3 mb-3">
          <img src="/logo-mini.svg" alt="MINI DECK" className="h-14 w-14 rounded-xl object-contain" />
          <div className="text-left leading-none">
            <div className="text-white font-black text-3xl tracking-widest">MINI DECK</div>
            <div className="text-[#F5C200] font-semibold text-sm tracking-[0.3em] uppercase mt-1">
              Marcenaria
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-9 h-9 rounded-xl bg-[#FFF9C2] flex items-center justify-center">
              <KeyRound size={18} className="text-[#CC8800]" />
            </div>
            <h2 className="text-lg font-bold text-[#111111]">Criar nova senha</h2>
          </div>
          <p className="text-sm text-slate-500 mb-6">
            {profile?.nome ? `Olá, ${profile.nome}! ` : ''}Por segurança, escolha uma senha pessoal antes de continuar.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">Nova senha</label>
              <div className="relative">
                <input
                  type={mostrar ? 'text' : 'password'}
                  value={senhaNova}
                  onChange={e => { setSenhaNova(e.target.value); setErro('') }}
                  className="input pr-10"
                  placeholder="mínimo 6 caracteres"
                  autoFocus
                />
                <button
                  type="button"
                  onClick={() => setMostrar(v => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                >
                  {mostrar ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <div>
              <label className="label">Confirmar senha</label>
              <input
                type={mostrar ? 'text' : 'password'}
                value={senhaConf}
                onChange={e => { setSenhaConf(e.target.value); setErro('') }}
                className="input"
                placeholder="repita a senha"
              />
            </div>

            {erro && (
              <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-sm text-red-600">
                {erro}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full justify-center mt-2"
            >
              {loading && <span className="w-4 h-4 border-2 border-[#111]/30 border-t-[#111] rounded-full animate-spin" />}
              {loading ? 'Salvando...' : 'Salvar senha e entrar'}
            </button>
          </form>
        </div>

        <button
          onClick={logout}
          className="text-center text-slate-500 text-xs mt-4 w-full hover:text-white transition-colors"
        >
          Sair da conta
        </button>
      </div>
    </div>
  )
}
